import { render } from "./DisputeComponent.vue?vue&type=template&id=6276db1e"
import script from "./DisputeComponent.vue?vue&type=script&lang=js"
export * from "./DisputeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__